import clsx from 'clsx';
import _ from 'lodash';

import { PendingChangesActionType } from 'constants/pendingChanges';

const generateKey = (row, index) => row.id ?? index;

// The field names a cell's pending-change highlight is checked against (PascalCase, as rows list them in
// modifiedFields), for looking up who changed them.
export const getCellFieldNames = ({ key, fieldName }) =>
  _.castArray(fieldName ?? key).map(name => _.upperFirst(name));

export const getRowData = ({
  row,
  rowIndex,
  isCustomDataDefinition,
  additionalRowContentRowId,
  additionalRowContent,
}) => {
  const rowKey = generateKey(row, rowIndex);
  const rowId = isCustomDataDefinition ? '' : row.id;
  const draggableId = String(rowId || rowKey);
  const isAdditionalRowContentVisible =
    additionalRowContentRowId === row.id && !!additionalRowContent;
  const isDeleted =
    row?.isDeleted || row?.pendingChangesActionType === PendingChangesActionType.DELETED;
  const isAdded = row?.isAdded || row?.pendingChangesActionType === PendingChangesActionType.ADDED;
  const isDisabled = row?.isDisabled;
  const isDragDisabled = row?.isDragDisabled;

  const rowPendingChangesActionType = clsx({
    [PendingChangesActionType.DELETED]: isDeleted,
    [PendingChangesActionType.ADDED]: !isDeleted && isAdded,
  });

  return {
    rowKey,
    rowId,
    draggableId,
    isAdditionalRowContentVisible,
    isDeleted,
    isAdded,
    isDisabled,
    isDragDisabled,
    rowPendingChangesActionType,
  };
};

export const getSearchAriaLabel = (searchAriaLabel, title) =>
  searchAriaLabel || (title ? `Search ${title}` : '');
